module.exports = __webpack_public_path__ + "img/317.d8578479.jpg";